function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _inheritsLoose(t, o) { t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { unByKey } from 'ol/Observable';
import React from 'react';
import debounce from '../utils/debounce';
import { Consumer } from '../components/Map';

/**
 * Higher order component (HOC) that allows any other component to monitor map
 * state, as long as it is contained in a Map component.
 *
 * **Note: Wrapped components will not be rendered until the map state is available.**
 *
 * @component
 */
export function provideMapState(WrappedComponent) {
  var MapStateMonitor = /*#__PURE__*/function (_React$Component) {
    function MapStateMonitor() {
      var _this;
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
      _defineProperty(_this, "state", {
        isInited: false
      });
      return _this;
    }
    _inheritsLoose(MapStateMonitor, _React$Component);
    var _proto = MapStateMonitor.prototype;
    _proto.componentDidMount = function componentDidMount() {
      if (this.props.mapContext) this.bindEvents();
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
      if (this.props.mapContext && !prevProps.mapContext) this.bindEvents();
    };
    _proto.bindEvents = function bindEvents() {
      var _this2 = this;
      var map = this.props.mapContext.map;
      if (map && map.getView()) {
        this.view = map.getView();
        this.addEvent(this.view.on('change:center', debounce(function (evt) {
          return _this2.onCenterChange();
        }, 500)));
        this.addEvent(this.view.on('change:resolution', debounce(function (evt) {
          return _this2.onZoomChange();
        }, 500)));
        this.onCenterChange();
      }
    };
    _proto.onCenterChange = function onCenterChange() {
      this.setState({
        isInited: true,
        mapCenter: this.props.mapContext.getPaddedCenter(),
        mapZoom: this.view.getZoom(),
        projCode: this.view.getProjection().getCode(),
        mapExtent: this.view.calculateExtent(this.props.mapContext.map.getSize())
      });
    };
    _proto.onZoomChange = function onZoomChange() {
      this.setState({
        mapZoom: this.view.getZoom()
      });
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
      // Disconnect from map
      if (this.eventKeys) {
        this.eventKeys.forEach(function (key) {
          return unByKey(key);
        });
      }
    };
    _proto.addEvent = function addEvent(key) {
      if (!this.eventKeys) this.eventKeys = [];
      this.eventKeys.push(key);
    };
    _proto.removeEvent = function removeEvent(key) {
      unByKey(key);
      var idx = this.eventKeys.indexOf(key);
      if (idx !== -1) this.eventKeys.splice(idx, 1);
    };
    _proto.render = function render() {
      if (!this.state.isInited) return null;
      var mapContext = this.props.mapContext;
      if (!mapContext) return;
      return /*#__PURE__*/React.createElement(WrappedComponent, _extends({
        setCenter: mapContext.setCenterAndZoom,
        setZoom: mapContext.setZoom,
        fitViewAndZoom: mapContext.fitViewAndZoom,
        forceUpdateMap: mapContext.forceUpdateMap,
        redrawLayer: mapContext.redrawLayer
      }, this.state, this.props));
    };
    return MapStateMonitor;
  }(React.Component);
  var MapStateConsumer = /*#__PURE__*/function (_React$Component2) {
    function MapStateConsumer() {
      return _React$Component2.apply(this, arguments) || this;
    }
    _inheritsLoose(MapStateConsumer, _React$Component2);
    var _proto2 = MapStateConsumer.prototype;
    _proto2.render = function render() {
      var _this3 = this;
      return /*#__PURE__*/React.createElement(Consumer, null, function (mapContext) {
        return /*#__PURE__*/React.createElement(MapStateMonitor, _extends({
          mapContext: mapContext
        }, _this3.props));
      });
    };
    return MapStateConsumer;
  }(React.Component);
  return MapStateConsumer;
}